import fg from 'fast-glob';

const PROJECT_SHARED_IGNORE = [
  '**/node_modules/**',
  '.next',
  'public',
  'dist',
  'build',
];

async function hasTailwindJsonConfig(cwd: string) {
  // We need Tailwind CSS to be configured.
  const resolvedTailwindJsonConfigPaths = await fg.glob('tailwind.config.*', {
    cwd,
    deep: 3,
    ignore: PROJECT_SHARED_IGNORE,
  });

  return Boolean(resolvedTailwindJsonConfigPaths.length);
}

export default hasTailwindJsonConfig;
